<template>
  <collapsed-section title="Emergency Contact">
    <error-banner v-if="error" :message="error"/>
    <labeled-form-control label="Name" :optional="true">
      <input v-model="name" class="form-control" type="text" placeholder="Name" :disabled="alternateContactUpdated"/>
    </labeled-form-control>
    <labeled-form-control label="Mobile" :optional="true">
      <input v-model="mobile" class="form-control" type="tel" placeholder="Mobile" :disabled="alternateContactUpdated"/>
    </labeled-form-control>
    <labeled-form-control label="Relationship" :optional="true">
      <select v-model="relationship" class="form-control custom-select" :disabled="alternateContactUpdated">
        <option value="">Select relationship</option>
        <option v-for="option in contactRelationshipOptions" :key="option" :value="option">{{ option }}</option>
      </select>
    </labeled-form-control>
    <labeled-form-control label="Note" :optional="true">
      <textarea v-model="otherInfo" class="form-control" rows="2" placeholder="Note" :disabled="alternateContactUpdated"/>
    </labeled-form-control>
    <!-- <labeled-form-control label="Active">
      <label class="ps-toggle-switch">
        <input v-model="isActive" class="toggle-checkbox" type="checkbox" :disabled="alternateContactUpdated">
        <div class="toggle-switch"></div>
      </label>
    </labeled-form-control> -->
  </collapsed-section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { AlternateContactUploadMixin } from '../../mixins/Registration/AlternateContactUploadMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import { ContactRelationshipOptionsCacheMixin } from '@/mixins/Shared/ContactRelationshipOptionsCacheMixin'
import CollapsedSection from '../Layout/CollapsedSection.vue'
import LabeledFormControl from '../Layout/LabeledFormControl.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'ClientEmergencyContactSection',
  mixins: [AlternateContactUploadMixin, ClientOnboardingInviteCacheMixin, ContactRelationshipOptionsCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ownerId () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientId : ''
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    vetContactUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setAlternateContactUpdated'
    ]),
    afterUpdateAlternateContact () {
      this.setAlternateContactUpdated()
    },
    afterAddAlternateContact () {
      this.setAlternateContactUpdated()
    },
    handleUpdateEvent () {
      if (!this.alternateContactUpdated && this.vetContactUpdated) {
        this.tryUploadAlternateContact()
      }
    }
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'error-banner': ErrorBanner
  }
}
</script>
